export const LOGOS = {
  light:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_42bc5da7-e7ef-4250-94cc-6bcaa1f6136f/artifacts/rucz7yzj_Thefrent%20foundation-Default%20Logo.png",
  dark:
    "https://customer-assets-rejwkqb3.emergentagent.net/job_42bc5da7-e7ef-4250-94cc-6bcaa1f6136f/artifacts/xsfp2hup_Thefrent%20foundation%20-%20Logo%20for%20Black%20or%20Dark%20Background.png",
};

export const IMAGES = {
  heroTeens:
    "https://static.prod-images.emergentagent.com/jobs/42bc5da7-e7ef-4250-94cc-6bcaa1f6136f/images/1b41c5d54c093a5c66fe6c97d05f1d867fd8ee6821f2d1c9394c58585bfd214b.jpeg",
  stripStudy:
    "https://static.prod-images.emergentagent.com/jobs/42bc5da7-e7ef-4250-94cc-6bcaa1f6136f/images/3102efafd3c03e43a4bad2ffff2cd45b7065865b8ee45d4980327c8848c047e5.jpeg",
  stripHands:
    "https://static.prod-images.emergentagent.com/jobs/42bc5da7-e7ef-4250-94cc-6bcaa1f6136f/images/9e0520695b0b0faa8f9a55dc3b543548da5eb66ce92fdabfee9bc81a945a5699.jpeg",
  stripVolleyball:
    "https://static.prod-images.emergentagent.com/jobs/42bc5da7-e7ef-4250-94cc-6bcaa1f6136f/images/40ee1358ae0cd1cd8b5d037f824dbcc8a7fc967101d2431160787e16e5a00af2.jpeg",
  stripReading:
    "https://static.prod-images.emergentagent.com/jobs/42bc5da7-e7ef-4250-94cc-6bcaa1f6136f/images/65158d5e390b95de7b0717207317d3bc7eca9e5177c037c49918d6224e60e43e.jpeg",
  heroBirds:
    "https://images.unsplash.com/photo-1633471684094-56eed57938e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  education:
    "https://images.unsplash.com/photo-1599689868384-59cb2b01bb21?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  athletics:
    "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  health:
    "https://images.unsplash.com/photo-1758274535230-3641d0632878?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  leadership:
    "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  innovation:
    "https://images.unsplash.com/photo-1592188627153-8157de983392?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hands:
    "https://images.unsplash.com/photo-1630068846062-3ffe78aa5049?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  classroom:
    "https://images.unsplash.com/photo-1758270705518-b61b40527e76?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000&auto=format",
  childReading:
    "https://images.unsplash.com/photo-1549737221-bef65e2604a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Programs", to: "/programs" },
  { label: "Impact", to: "/impact" },
  { label: "Get Involved", to: "/get-involved" },
];

export const FOCUS_AREAS = [
  {
    id: "education",
    number: "01",
    icon: "GraduationCap",
    title: "Education",
    blurb: "Scholarships, STEM, workforce readiness, and lifelong learning.",
    detail:
      "We expand access to quality education through scholarships, STEM programming, tutoring, and workforce-readiness initiatives that prepare learners of every age for what's next.",
    image: IMAGES.stripStudy,
  },
  {
    id: "athletics",
    number: "02",
    icon: "Trophy",
    title: "Athletics",
    blurb: "Youth sports, adaptive athletics, equipment assistance, and coach development.",
    detail:
      "From youth leagues to adaptive athletics, we remove barriers with equipment assistance, safe facilities, and coach development so every athlete can compete and belong.",
    image: IMAGES.stripVolleyball,
  },
  {
    id: "health",
    number: "03",
    icon: "HeartPulse",
    title: "Health & Wellness",
    blurb: "Promoting physical health, mental wellness, nutrition, and injury prevention.",
    detail:
      "We champion whole-person wellbeing — physical health, mental wellness, nutrition education, and injury prevention — building healthier individuals and communities.",
    image: IMAGES.health,
  },
  {
    id: "leadership",
    number: "04",
    icon: "Users",
    title: "Leadership",
    blurb: "Developing character, mentorship, civic engagement, and future leaders.",
    detail:
      "Through mentorship, character development, and civic engagement, we cultivate the confident, principled leaders our communities will depend on tomorrow.",
    image: IMAGES.leadership,
  },
  {
    id: "innovation",
    number: "05",
    icon: "Lightbulb",
    title: "Innovation",
    blurb: "Supporting innovation, research, technology access, and community advancement.",
    detail:
      "We fund ideas that move communities forward — research, technology access, and creative problem-solving that turn ambition into lasting advancement.",
    image: IMAGES.innovation,
  },
];

export const SECURITY = [
  {
    icon: "ShieldCheck",
    title: "Protected End to End",
    text: "Your information is encrypted and safeguarded at every step, so you can give and connect with complete peace of mind.",
  },
  {
    icon: "Lock",
    title: "Secure Donations",
    text: "Every gift is processed through trusted, bank-level secure systems built to keep your money and details safe.",
  },
  {
    icon: "CreditCard",
    title: "We Never See Your Card",
    text: "Payments are handled by Stripe, a global leader in secure payments — your card details never touch our systems.",
  },
  {
    icon: "EyeOff",
    title: "Your Privacy, Respected",
    text: "We only ask for what we truly need, and we never sell or share your personal information.",
  },
];

export const STATS = [
  { value: 5, suffix: "", label: "Focus Areas", sub: "Education to Innovation" },
  { value: 3, suffix: "", label: "Ways to Give", sub: "Donate · Volunteer · Partner" },
  { value: 100, suffix: "%", label: "Mission-Driven", sub: "Every dollar with purpose" },
  { value: "Virginia", suffix: "", label: "Where We Began", sub: "Serving our communities" },
];

export const GOALS = [
  { value: 150, suffix: "+", label: "Learners we aim to support in year one" },
  { value: 25, suffix: "K", prefix: "$", label: "Scholarships & grants to commit" },
  { value: 7, suffix: "+", label: "Community partners to engage" },
  { value: 3, suffix: "", label: "Programs to launch" },
];

export const PRESET_AMOUNTS = [25, 50, 100, 250, 500, 1000];

export const LEADERSHIP = [
  { name: "Shawna-Kay McPherson", role: "Founder · Director" },
  { name: "Monique Henry", role: "Director" },
  { name: "Clairease Booker", role: "Director" },
];

export const LEGAL = {
  name: "Thefrent Foundation Inc.",
  state: "Commonwealth of Virginia",
  status: "Nonprofit organization",
  registeredOffice: "4445 Corporation Lane, Suite 259, Virginia Beach, VA 23462",
  principalOffice: "440 Monticello Ave, Ste 1802 #456405, Norfolk, VA 23510",
  email: "thefrentfoundation@thefrent.com",
  phone: "757-209-4786",
  impactLine: "Making an impact in communities everywhere.",
};
